var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.offlineConfirmed)?_c('Layout',[_c('h1',{class:_vm.$style.title},[_vm._v(" The page timed out while loading. Are you sure you're still connected to the Internet? ")])]):_c('LoadingView')
}
var staticRenderFns = []

export { render, staticRenderFns }